// import React, { useState, useEffect, useRef, FormEvent, Fragment } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Nav,
//   NavItem,
//   NavLink,
//   TabContent,
//   TabPane,
//   Input,
//   InputGroup,
//   InputGroupText,
//   Form,
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
//   Spinner,
// } from "reactstrap";
// import {
//   Search,
//   MoreVertical,
//   Mic,
//   Smile,
//   Paperclip,
//   Send,
//   CheckCircle,
//   Clock,
//   ArrowLeft,
//   Filter,
//   MessageSquare,
// } from "react-feather";
// import EmojiPicker from "emoji-picker-react";
// import axios from "axios";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import { CustomerSupportTitle, Support, Href } from "../../../Utils/Constants";
// import { ChatApi, ChatContactApi, ChatMembersApi } from "../../../api";
// import {
//   setAllMembers,
//   setChats,
//   setContacts,
//   searchMember,
//   changeChat,
//   createNewChatAsync,
//   fetchChatMemberAsync,
//   setSelectedUser,
//   replyByUserAsync,
//   sendMessageAsync,
// } from "../../../ReduxToolkit/Reducers/ChatReducer";
// import { RootState } from "../../../ReduxToolkit/Store";
// import {
//   AllMembersType,
//   ChatConversation,
//   ChatType,
//   MessagesType,
//   ContactParentItem,
//   ContactChildItem,
// } from "../../../Types/Chat.type";
// import { Badges, Image, LI, P, UL, Btn } from "../../../AbstractElements";
// import { dynamicImage } from "../../../Utils";
// import DashboardSvgIcon from "../../../Utils/CommonComponents/DashboardSvgIcon";
// import { apiGet, apiPost, mediaUrl } from "../../../Utils/FileUpload";
// import Echo from "laravel-echo";
// import Pusher from "pusher-js";
// import Skeleton from "react-loading-skeleton";
// import 'react-loading-skeleton/dist/skeleton.css';
// interface SupportItem {
//   id: number;
//   name: string;
//   description: string;
//   ticket: string;
//   created_at: string;
//   category: string;
//   status: string;
//   file: string;
//   // Add any other properties you expect
// }
// type EchoInstance = InstanceType<typeof Echo>;

// declare global {
//   interface Window {
//     Pusher: typeof Pusher;
//     Echo: EchoInstance;
//   }
// }
// export default function CustomerSupport() {
//   // Redux hooks
//   const dispatch = useDispatch();
//   // State management
//   const [activeTab, setActiveTab] = useState(1);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [messageInput, setMessageInput] = useState("");
//   const [isResolving, setIsResolving] = useState(false);
//   const [customerSupports, setCustomerSupports] = useState<SupportItem[]>([]);
//   const [customerChat, setCustomerChat] = useState<any[]>([]);
//   const [selectedSupport, setSelectedSupport] = useState<SupportItem | null>(
//     null
//   );
//   const [isLoadingSupports, setIsLoadingSupports] = useState(true);
//   const [isLoadingChat, setIsLoadingChat] = useState(false);
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [mobileShowChat, setMobileShowChat] = useState(false);

//   // Helper avatar and badge formatters
//   const getInitials = (name: string) => {
//     if (!name) return "CS";
//     const parts = name.trim().split(" ");
//     if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
//     return name.slice(0, 2).toUpperCase();
//   };

//   const getStatusBadge = (status: string) => {
//     switch (status) {
//       case "New":
//         return <span className="badge rounded-pill bg-warning text-dark px-2 py-1" style={{ fontSize: "11px" }}>● New</span>;
//       case "In Progress":
//         return <span className="badge rounded-pill bg-info text-white px-2 py-1" style={{ fontSize: "11px" }}>● In Progress</span>;
//       case "Resolved":
//         return <span className="badge rounded-pill bg-success text-white px-2 py-1" style={{ fontSize: "11px" }}>● Resolved</span>;
//       default:
//         return <span className="badge rounded-pill bg-secondary text-white px-2 py-1" style={{ fontSize: "11px" }}>{status || "Open"}</span>;
//     }
//   };
//   // Refs
//   const chatHistoryRef = useRef<HTMLDivElement | null>(null);
//   const bottomRef = useRef<null | HTMLDivElement>(null);
//   const echoRef = useRef<EchoInstance | null>(null);
//   // Derived values
//   const activeChat =
//     selectedSupport && selectedSupport.id ? selectedSupport.id : 0;

//   const handleMessageChange = (message: string) => {
//     setMessageInput(message);
//   };

//   useEffect(() => {
//     // Initialize Pusher client
//     const pusherClient = new Pusher("dnnieup1cluc4xan8ao6", {
//       wsHost: "192.168.1.72", // Your server IP
//       wsPort: 8080,
//       forceTLS: false,
//       enabledTransports: ["ws", "wss"],
//       cluster: "mt1",
//     });

//     // Initialize Echo
//     echoRef.current = new Echo({
//       broadcaster: "pusher",
//       client: pusherClient,
//     });

//     // Listen for messages

//     echoRef.current
//       .channel(`support.${selectedSupport?.id}`)
//       .listen("MessageSent", (data: any) => {
//         setCustomerChat((prev) => [...prev, data]);
//       });

//     return () => {
//       if (echoRef.current) {
//         echoRef.current.leave(`support.${selectedSupport?.id}`);
//       }
//     };
//   }, [selectedSupport?.id]);
//   const handleMessagePress = async () => {
//     if (!messageInput.length || !selectedSupport) return;

//     try {
//       const payload = {
//         customer_support_id: selectedSupport.id,
//         message: messageInput,
//         status: "In Progress", // This will update the ticket status
//       };

//       const response = await apiPost(
//         "support_message/storeMessage",
//         payload
//       );
//       console.log("Message sent:", response);

//       // Refresh the chat messages after sending
//       fetchCustomerChatById(selectedSupport.id);

//       // Update local state to reflect status change
//       if (selectedSupport.status !== "In Progress") {
//         setSelectedSupport((prev) =>
//           prev ? { ...prev, status: "In Progress" } : null
//         );
//         setCustomerSupports((prev) =>
//           prev.map((item) =>
//             item.id === selectedSupport.id
//               ? { ...item, status: "In Progress" }
//               : item
//           )
//         );
//       }

//       setMessageInput("");
//     } catch (error) {
//       console.error("Error sending message:", error);
//     }
//   };

//   const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     handleMessagePress();
//   };

//   const changeChatClick = (supportItem: any) => {
//     setSelectedSupport(supportItem);
//     setMobileShowChat(true);
//     fetchCustomerChatById(supportItem.id);
//   };

//   const handleSearchKeyword = (keyword: string) => {
//     setSearchKeyword(keyword);
//     // Filter customer supports based on search keyword
//     const filtered = customerSupports.filter((item: any) =>
//       (item.name || '').toLowerCase().includes(keyword.toLowerCase()) ||
//       (item.category || '').toLowerCase().includes(keyword.toLowerCase()) ||
//       (item.description || '').toLowerCase().includes(keyword.toLowerCase()) ||
//       (item.ticket || '').includes(keyword)
//     );

//   };

//   // API functions
//   const fetchChatApiData = async () => {
//     try {
//       const response = await axios.get(ChatApi);
//       dispatch(setChats(response.data.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatMemberApiData = async () => {
//     try {
//       const response = await axios.get(ChatMembersApi);
//       dispatch(setAllMembers(response.data));
//       return response.data;
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchChatContactApiData = async () => {
//     try {
//       const response = await axios.get(ChatContactApi);
//       dispatch(setContacts(response.data));
//     } catch (error) {
//       console.error("data not fetched", error);
//     }
//   };

//   const fetchCustomerChatById = async (supportId: number) => {
//     setIsLoadingChat(true);
//     try {
//       const payload = {
//         customer_support_id: supportId,
//       };
//       const response = await apiPost("customer_supportmessage/get", payload);
//       setCustomerChat(response.data || response);
//     } catch (err) {
//       console.error("Error fetching customer chat:", err);
//     } finally {
//       setIsLoadingChat(false);
//     }
//   };

//   // Effects
//   useEffect(() => {
//     fetchChatApiData();
//     fetchChatMemberApiData();
//     fetchChatContactApiData();
//   }, []);

//   useEffect(() => {
//     if (chatHistoryRef.current) {
//       chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
//     }
//   }, [customerChat]);

//   useEffect(() => {
//     const fetchCustomerSupports = async () => {
//       setIsLoadingSupports(true);
//       try {
//         const response = await apiGet("customer_support_getall");
//         console.log("API Response:", response);
//         const supportsData = response.data || response;
//         setCustomerSupports(supportsData);

//         // Don't auto-select any support item - keep right side empty initially
//       } catch (err) {
//         console.error("Error fetching customer supports:", err);
//       } finally {
//         setIsLoadingSupports(false);
//       }
//     };

//     fetchCustomerSupports();
//   }, []);

//   // Filter customer supports based on search and status
//   const filteredCustomerSupports = customerSupports.filter(
//     (item: any) => {
//       const matchesSearch =
//         (item.name || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
//         (item.category || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
//         (item.description || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
//         (item.ticket || '').includes(searchKeyword);
//       const matchesStatus =
//         statusFilter === "All" ? true : item.status === statusFilter;
//       return matchesSearch && matchesStatus;
//     }
//   );

//   const handleResolveTicket = async () => {
//     if (!selectedSupport) return;

//     setIsResolving(true);
//     try {
//       const response = await apiPost("customer_support/resolve", {
//         id: selectedSupport.id,
//         status: "Resolved",
//       });

//       // Update local state - with proper null checks
//       setSelectedSupport((prev) => {
//         if (!prev) return null;
//         return { ...prev, status: "Resolved" };
//       });

//       setCustomerSupports((prev) =>
//         prev.map((item) =>
//           item.id === selectedSupport.id
//             ? { ...item, status: "Resolved" }
//             : item
//         )
//       );

//       console.log("Ticket resolved:", response);
//     } catch (error) {
//       console.error("Error resolving ticket:", error);
//     } finally {
//       setIsResolving(false);
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={CustomerSupportTitle}
//         parent={Support}
//         title={CustomerSupportTitle}
//       />
//       <Row className="g-0">
//         {/* Left Ticket List Sidebar */}
//         <Col
//           xxl={3}
//           xl={4}
//           md={5}
//           xs={12}
//           className={`box-col-5 ${mobileShowChat ? "d-none d-md-block" : "d-block"}`}
//         >
//           <Card className="left-sidebar-wrapper border-end h-100 shadow-sm">
//             <div className="left-sidebar-chat pb-2 border-bottom">
//               {/* Status Filter Pills */}
//               <div className="d-flex flex-wrap gap-1">
//                 {["All", "New", "In Progress", "Resolved"].map((st) => (
//                   <button
//                     key={st}
//                     className={`btn btn-xs rounded-pill px-2 py-1 ${statusFilter === st
//                       ? st === "Resolved"
//                         ? "btn-success"
//                         : st === "In Progress"
//                           ? "btn-info text-white"
//                           : st === "New"
//                             ? "btn-warning text-dark"
//                             : "btn-primary"
//                       : "btn-light text-dark border"
//                       }`}
//                     style={{ fontSize: "11px", fontWeight: "600" }}
//                     onClick={() => setStatusFilter(st)}
//                   >
//                     {st}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="advance-options overflow-auto" style={{ maxHeight: "calc(100vh - 280px)" }}>
//               {isLoadingSupports ? (
//                 <div className="p-3">
//                   {[...Array(6)].map((_, i) => (
//                     <div key={i} className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
//                       <Skeleton circle width={40} height={40} />
//                       <div className="flex-grow-1">
//                         <div className="d-flex justify-content-between mb-1">
//                           <Skeleton width={110} height={14} />
//                           <Skeleton width={50} height={14} />
//                         </div>
//                         <Skeleton width={150} height={12} />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <TabContent activeTab={activeTab}>
//                   <TabPane tabId={1}>
//                     <>
//                       {filteredCustomerSupports && filteredCustomerSupports.length > 0 ? (
//                         <UL className="chats-user simple-list list-group list-group-flush" style={{ height: "auto", overflow: "visible" }}>
//                           {filteredCustomerSupports.map((item: any, i: number) => {
//                             const isSelected = activeChat === item.id;
//                             return (
//                               <LI
//                                 key={i}
//                                 className={`list-group-item list-group-item-action p-3 border-bottom cursor-pointer ${isSelected ? "bg-light-primary border-start border-primary border-1" : ""
//                                   }`}
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() => changeChatClick(item)}
//                               >
//                                 <div className="d-flex align-items-start gap-2 overflow-hidden w-100">
//                                   <div
//                                     className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white flex-shrink-0"
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)",
//                                       fontSize: "14px",
//                                       boxShadow: "0 2px 6px rgba(22, 130, 124, 0.2)",
//                                     }}
//                                   >
//                                     {getInitials(item.name || item.category || "CS")}
//                                   </div>
//                                   <div className="flex-grow-1 overflow-hidden text-start" style={{ textAlign: "left" }}>
//                                     <div className="d-flex align-items-center justify-content-between mb-1">
//                                       <h6 className="mb-0 text-dark fw-bold text-truncate text-start" style={{ maxWidth: "130px", fontSize: "13px", textAlign: "left" }}>
//                                         {item.name || "Customer"}
//                                       </h6>
//                                       <span className="badge bg-primary text-white" style={{ fontSize: "11px", fontWeight: "600" }}>
//                                         #{item.ticket}
//                                       </span>
//                                     </div>
//                                     <p className="text-muted small mb-1 text-truncate text-start" style={{ fontSize: "12px", textAlign: "left" }}>
//                                       {item.description || item.category}
//                                     </p>
//                                     <div className="d-flex align-items-center justify-content-between">
//                                       <span className="text-muted" style={{ fontSize: "11px" }}>
//                                         {item.created_at ? new Date(item.created_at).toLocaleDateString() : ""}
//                                       </span>
//                                       {getStatusBadge(item.status)}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </LI>
//                             );
//                           })}
//                         </UL>
//                       ) : (
//                         <div className="text-center p-4 text-muted">
//                           <MessageSquare size={32} className="mb-2 text-muted" />
//                           <p className="mb-0">No customer support tickets found.</p>
//                         </div>
//                       )}
//                     </>
//                   </TabPane>
//                 </TabContent>
//               )}
//             </div>
//           </Card>
//         </Col>

//         {/* Right Chat & Detail Panel */}
//         <Col
//           xxl={9}
//           xl={8}
//           md={7}
//           xs={12}
//           className={`box-col-7 ${mobileShowChat ? "d-block" : "d-none d-md-block"}`}
//         >
//           <Card className="right-sidebar-chat shadow-sm h-100 mb-0">
//             {selectedSupport ? (
//               <>
//                 {/* Header Bar */}
//                 <div className="right-sidebar-title p-3 border-bottom bg-white">
//                   <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
//                     <div className="d-flex align-items-center gap-2">
//                       <button
//                         className="btn btn-outline-secondary btn-sm me-1 d-md-none"
//                         onClick={() => setMobileShowChat(false)}
//                         title="Back to Tickets"
//                       >
//                         <ArrowLeft size={16} />
//                       </button>
//                       <div
//                         className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white"
//                         style={{
//                           width: "40px",
//                           height: "40px",
//                           background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {getInitials(selectedSupport.name || "Customer")}
//                       </div>
//                       <div>
//                         <h6 className="mb-0 text-dark fw-bold">{selectedSupport.name || "Customer"}</h6>
//                         <span className="text-muted small">Ticket #{selectedSupport.ticket}</span>
//                       </div>
//                     </div>
//                     <div>
//                       {selectedSupport?.status === "Resolved" ? (
//                         <span className="badge bg-success-light text-success fw-bold px-3 py-2 border border-success">
//                           <i className="fa fa-check-circle me-1" /> Resolved
//                         </span>
//                       ) : (
//                         <button
//                           className="btn btn-success btn-sm px-3 fw-semibold"
//                           onClick={handleResolveTicket}
//                           disabled={isResolving}
//                         >
//                           {isResolving ? (
//                             <>
//                               <span className="spinner-border spinner-border-sm me-2" />
//                               Resolving...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fa fa-check-circle me-1" /> Mark Resolved
//                             </>
//                           )}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="right-sidebar-Chats p-3" style={{ height: "calc(100vh - 270px)", overflowY: "auto" }}>
//                   <div className="msger">
//                     <div className="msger-chat" ref={chatHistoryRef}>
//                       {isLoadingChat ? (
//                         <div className="d-flex flex-column align-items-center justify-content-center h-100 p-5 my-auto" style={{ minHeight: "350px" }}>
//                           <Spinner color="primary" />
//                           <p className="mt-2 text-muted fw-semibold">Loading conversation...</p>
//                         </div>
//                       ) : (
//                         <>
//                           {/* Ticket Summary Hero Card */}
//                           {selectedSupport && (
//                             <div className="card border-0 mb-4 shadow-sm rounded-3 overflow-hidden bg-light">
//                               <div
//                                 className="p-3 text-white"
//                                 style={{ background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)" }}
//                               >
//                                 <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//                                   <div>
//                                     <span className="badge bg-white text-dark me-2">
//                                       #{selectedSupport.ticket}
//                                     </span>
//                                     <strong className="fs-6">{selectedSupport.category || "Support Query"}</strong>
//                                   </div>
//                                   <div>
//                                     {getStatusBadge(selectedSupport.status)}
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="card-body p-3 bg-white">
//                                 <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
//                                   <span className="text-muted small">
//                                     <Clock size={12} className="me-1" /> Created:{" "}
//                                     {selectedSupport.created_at ? new Date(selectedSupport.created_at).toLocaleString() : "N/A"}
//                                   </span>
//                                   {selectedSupport.file && (
//                                     <a
//                                       href={`${mediaUrl}/${selectedSupport.file}`}
//                                       target="_blank"
//                                       rel="noopener noreferrer"
//                                       className="btn btn-xs btn-outline-primary px-2 py-1"
//                                     >
//                                       <Paperclip size={12} className="me-1" /> View Attachment
//                                     </a>
//                                   )}
//                                 </div>
//                                 <div className="p-3 bg-light rounded border">
//                                   <strong className="text-dark d-block small mb-1">Issue Description:</strong>
//                                   <span className="text-dark small">{selectedSupport.description}</span>
//                                 </div>
//                               </div>
//                             </div>
//                           )}

//                           {/* Conversation Messages */}
//                           {customerChat && customerChat.length > 0 ? (
//                             customerChat.map((item: any, index: number) => {
//                               const isCustomer = item.customer_id !== null;
//                               return (
//                                 <div
//                                   className={`msg ${isCustomer ? "left" : "right"}-msg mb-3`}
//                                   key={index}
//                                 >
//                                   <div className="msg-bubble p-3 rounded-3 shadow-sm" style={{
//                                     maxWidth: "75%",
//                                     backgroundColor: isCustomer ? "#ffffff" : "#16827c",
//                                     color: isCustomer ? "#212529" : "#ffffff",
//                                     border: isCustomer ? "1px solid #e2e8f0" : "none",
//                                   }}>
//                                     <div className="msg-info d-flex justify-content-between align-items-center mb-1 gap-3">
//                                       <strong className="msg-info-name small" style={{ color: isCustomer ? "#16827c" : "#f8fafc" }}>
//                                         {isCustomer ? (selectedSupport?.name || "Customer") : "Support Admin"}
//                                       </strong>
//                                       <span className="msg-info-time small" style={{ fontSize: "10px", opacity: 0.8 }}>
//                                         {new Date(item.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                                       </span>
//                                     </div>
//                                     <div className="msg-text" style={{ fontSize: "13px", lineHeight: "1.4" }}>
//                                       {item.message}
//                                     </div>
//                                   </div>
//                                 </div>
//                               );
//                             })
//                           ) : (
//                             <div className="text-center p-4 my-4">
//                               <MessageSquare size={40} className="text-muted mb-2" />
//                               <h6 className="text-dark fw-bold">Start Conversation</h6>
//                               <p className="text-muted small">Send a message below to communicate with customer.</p>
//                             </div>
//                           )}
//                         </>
//                       )}
//                       <div ref={bottomRef} />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Send Message Area */}
//                 <div className="p-3 border-top bg-white">
//                   {selectedSupport?.status === "Resolved" ? (
//                     <div className="alert alert-success text-center mb-0 py-2 small fw-semibold">
//                       <CheckCircle size={14} className="me-1" /> This support ticket has been resolved.
//                     </div>
//                   ) : (
//                     <Form className="d-flex align-items-center gap-2" onSubmit={(e: FormEvent<HTMLFormElement>) => handleSubmit(e)}>
//                       <Input
//                         type="text"
//                         className="form-control flex-grow-1"
//                         placeholder="Type your response message..."
//                         value={messageInput}
//                         onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleMessageChange(e.target.value)}
//                       />
//                       <Btn
//                         color="primary"
//                         className="d-flex align-items-center justify-content-center px-3"
//                         disabled={!messageInput.trim()}
//                         style={{ height: "38px" }}
//                       >
//                         <Send size={14} className="me-1" /> Send
//                       </Btn>
//                     </Form>
//                   )}
//                 </div>
//               </>
//             ) : (
//               /* Empty Selection State */
//               <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5 my-auto" style={{ minHeight: "400px" }}>
//                 <div className="p-4 bg-light-primary rounded-circle mb-3">
//                   <MessageSquare size={48} className="text-primary" />
//                 </div>
//                 <h4 className="fw-bold text-dark mb-2">Customer Support Portal</h4>
//                 <p className="text-muted mb-0" style={{ maxWidth: "380px" }}>
//                   Select any support ticket from the left sidebar to inspect details, download attachments, and respond to customer queries.
//                 </p>
//               </div>
//             )}
//           </Card>
//         </Col>
//       </Row>
//     </>
//   );
// }

// // ///without event
import React, { useState, useEffect, useRef, FormEvent, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  InputGroupText,
  Form,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import {
  Search,
  MoreVertical,
  Mic,
  Smile,
  Paperclip,
  Send,
  CheckCircle,
  Clock,
  ArrowLeft,
  Filter,
  MessageSquare,
} from "react-feather";
import EmojiPicker from "emoji-picker-react";
import axios from "axios";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { CustomerSupportTitle, Support, Href } from "../../../Utils/Constants";
import { ChatApi, ChatContactApi, ChatMembersApi } from "../../../api";
import {
  setAllMembers,
  setChats,
  setContacts,
  searchMember,
  changeChat,
  createNewChatAsync,
  fetchChatMemberAsync,
  setSelectedUser,
  replyByUserAsync,
  sendMessageAsync,
} from "../../../ReduxToolkit/Reducers/ChatReducer";
import { RootState } from "../../../ReduxToolkit/Store";
import {
  AllMembersType,
  ChatConversation,
  ChatType,
  MessagesType,
  ContactParentItem,
  ContactChildItem,
} from "../../../Types/Chat.type";
import { Badges, Image, LI, P, UL, Btn } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import DashboardSvgIcon from "../../../Utils/CommonComponents/DashboardSvgIcon";
import { apiGet, apiPost, mediaUrl } from "../../../Utils/FileUpload";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
interface SupportItem {
  id: number;
  name: string;
  description: string;
  ticket: string;
  created_at: string;
  category: string;
  status: string;
  file: string;
  // Add any other properties you expect
}

export default function CustomerSupport() {
  // Redux hooks
  const dispatch = useDispatch();
  const { chatContact, members, currentUser, selectedUser, chats, allMembers } =
    useSelector((state: RootState) => state.chat);

  // State management
  const [activeTab, setActiveTab] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [isResolving, setIsResolving] = useState(false);
  const [customerSupports, setCustomerSupports] = useState<SupportItem[]>([]);
  const [customerChat, setCustomerChat] = useState<any[]>([]);
  const [selectedSupport, setSelectedSupport] = useState<SupportItem | null>(
    null
  );
  const [isLoadingSupports, setIsLoadingSupports] = useState(true);
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [mobileShowChat, setMobileShowChat] = useState(false);

  // Helper avatar and badge formatters
  const getInitials = (name: string) => {
    if (!name) return "CS";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    return name.slice(0, 2).toUpperCase();
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "New":
        return <span className="badge rounded-pill bg-warning text-dark px-2 py-1" style={{ fontSize: "11px" }}>● New</span>;
      case "In Progress":
        return <span className="badge rounded-pill bg-info text-white px-2 py-1" style={{ fontSize: "11px" }}>● In Progress</span>;
      case "Resolved":
        return <span className="badge rounded-pill bg-success text-white px-2 py-1" style={{ fontSize: "11px" }}>● Resolved</span>;
      default:
        return <span className="badge rounded-pill bg-secondary text-white px-2 py-1" style={{ fontSize: "11px" }}>{status || "Open"}</span>;
    }
  };
  // Refs
  const chatHistoryRef = useRef<HTMLDivElement | null>(null);
  const bottomRef = useRef<null | HTMLDivElement>(null);

  // Derived values
  const activeChat =
    selectedSupport && selectedSupport.id ? selectedSupport.id : 0;

  // Helper functions
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggledrop = () => setDropdown(!dropdown);

  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };

  const handleMessageChange = (message: string) => {
    setMessageInput(message);
  };

  const handleMessagePress = async () => {
    if (isSending || !messageInput.trim() || !selectedSupport) return;

    setIsSending(true);
    try {
      const payload = {
        customer_support_id: selectedSupport.id,
        message: messageInput,
        status: "In Progress", // This will update the ticket status
      };

      const response = await apiPost(
        "support_message/storeMessage",
        payload
      );
      console.log("Message sent:", response);

      setMessageInput("");

      // Refresh the chat messages quietly without full screen loading spinner
      await fetchCustomerChatById(selectedSupport.id, false);

      // Update local state to reflect status change
      if (selectedSupport.status !== "In Progress") {
        setSelectedSupport((prev) =>
          prev ? { ...prev, status: "In Progress" } : null
        );
        setCustomerSupports((prev) =>
          prev.map((item) =>
            item.id === selectedSupport.id
              ? { ...item, status: "In Progress" }
              : item
          )
        );
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsSending(false);
    }
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleMessagePress();
  };

  const changeChatClick = (supportItem: any) => {
    setSelectedSupport(supportItem);
    setMobileShowChat(true);
    fetchCustomerChatById(supportItem.id);
  };

  const handleSearchKeyword = (keyword: string) => {
    setSearchKeyword(keyword);
  };

  // API functions
  const fetchChatApiData = async () => {
    try {
      const response = await axios.get(ChatApi);
      dispatch(setChats(response.data.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatMemberApiData = async () => {
    try {
      const response = await axios.get(ChatMembersApi);
      dispatch(setAllMembers(response.data));
      return response.data;
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatContactApiData = async () => {
    try {
      const response = await axios.get(ChatContactApi);
      dispatch(setContacts(response.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchCustomerChatById = async (supportId: number, showLoading = true) => {
    if (showLoading) setIsLoadingChat(true);
    try {
      const payload = {
        customer_support_id: supportId,
      };
      const response = await apiPost("customer_supportmessage/get", payload);
      setCustomerChat(response.data || response);
    } catch (err) {
      console.error("Error fetching customer chat:", err);
    } finally {
      if (showLoading) setIsLoadingChat(false);
    }
  };

  // Effects
  useEffect(() => {
    fetchChatApiData();
    fetchChatMemberApiData();
    fetchChatContactApiData();
  }, []);

  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  }, [customerChat]);

  useEffect(() => {
    const fetchCustomerSupports = async () => {
      setIsLoadingSupports(true);
      try {
        const response = await apiGet("customer_support_getall");
        console.log("API Response:", response);
        const supportsData = response.data || response;
        setCustomerSupports(supportsData);

        // Don't auto-select any support item - keep right side empty initially
      } catch (err) {
        console.error("Error fetching customer supports:", err);
      } finally {
        setIsLoadingSupports(false);
      }
    };

    fetchCustomerSupports();
  }, []);

  // Filter customer supports based on search and status
  const filteredCustomerSupports = customerSupports.filter(
    (item: any) => {
      const matchesSearch =
        (item.name || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
        (item.category || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
        (item.description || '').toLowerCase().includes(searchKeyword.toLowerCase()) ||
        (item.ticket || '').includes(searchKeyword);
      const matchesStatus =
        statusFilter === "All" ? true : item.status === statusFilter;
      return matchesSearch && matchesStatus;
    }
  );

  const handleResolveTicket = async () => {
    if (!selectedSupport) return;

    setIsResolving(true);
    try {
      const response = await apiPost("customer_support/resolve", {
        id: selectedSupport.id,
        status: "Resolved",
      });

      // Update local state - with proper null checks
      setSelectedSupport((prev) => {
        if (!prev) return null;
        return { ...prev, status: "Resolved" };
      });

      setCustomerSupports((prev) =>
        prev.map((item) =>
          item.id === selectedSupport.id
            ? { ...item, status: "Resolved" }
            : item
        )
      );

      console.log("Ticket resolved:", response);
    } catch (error) {
      console.error("Error resolving ticket:", error);
    } finally {
      setIsResolving(false);
    }
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={CustomerSupportTitle}
        parent={Support}
        title={CustomerSupportTitle}
      />
      <Row className="g-0">
        {/* Left Ticket List Sidebar */}
        <Col
          xxl={3}
          xl={4}
          md={5}
          xs={12}
          className={`box-col-5 ${mobileShowChat ? "d-none d-md-block" : "d-block"}`}
        >
          <Card className="left-sidebar-wrapper border-end h-100 shadow-sm">
            <div className="left-sidebar-chat pb-2 border-bottom">
              {/* Status Filter Pills */}
              <div className="d-flex flex-wrap gap-1">
                {["All", "New", "In Progress", "Resolved"].map((st) => (
                  <button
                    key={st}
                    className={`btn btn-xs rounded-pill px-2 py-1 ${statusFilter === st
                      ? st === "Resolved"
                        ? "btn-success"
                        : st === "In Progress"
                          ? "btn-info text-white"
                          : st === "New"
                            ? "btn-warning text-dark"
                            : "btn-primary"
                      : "btn-light text-dark border"
                      }`}
                    style={{ fontSize: "11px", fontWeight: "600" }}
                    onClick={() => setStatusFilter(st)}
                  >
                    {st}
                  </button>
                ))}
              </div>
            </div>

            <div className="advance-options overflow-auto" style={{ maxHeight: "calc(100vh - 280px)" }}>
              {isLoadingSupports ? (
                <div className="p-3">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                      <Skeleton circle width={40} height={40} />
                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between mb-1">
                          <Skeleton width={110} height={14} />
                          <Skeleton width={50} height={14} />
                        </div>
                        <Skeleton width={150} height={12} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={1}>
                    <>
                      {filteredCustomerSupports && filteredCustomerSupports.length > 0 ? (
                        <UL className="chats-user simple-list list-group list-group-flush" style={{ height: "auto", overflow: "visible" }}>
                          {filteredCustomerSupports.map((item: any, i: number) => {
                            const isSelected = activeChat === item.id;
                            return (
                              <LI
                                key={i}
                                className={`list-group-item list-group-item-action p-3 border-bottom cursor-pointer ${isSelected ? "bg-light-primary border-start border-primary border-1" : ""
                                  }`}
                                style={{ cursor: "pointer" }}
                                onClick={() => changeChatClick(item)}
                              >
                                <div className="d-flex align-items-start gap-2 overflow-hidden w-100">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white flex-shrink-0"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)",
                                      fontSize: "14px",
                                      boxShadow: "0 2px 6px rgba(22, 130, 124, 0.2)",
                                    }}
                                  >
                                    {getInitials(item.name || item.category || "CS")}
                                  </div>
                                  <div className="flex-grow-1 overflow-hidden text-start" style={{ textAlign: "left" }}>
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                      <h6 className="mb-0 text-dark fw-bold text-truncate text-start" style={{ maxWidth: "130px", fontSize: "13px", textAlign: "left" }}>
                                        {item.name || "Customer"}
                                      </h6>
                                      <span className="badge bg-primary text-white" style={{ fontSize: "11px", fontWeight: "600" }}>
                                        #{item.ticket}
                                      </span>
                                    </div>
                                    <p className="text-muted small mb-1 text-truncate text-start" style={{ fontSize: "12px", textAlign: "left" }}>
                                      {item.description || item.category}
                                    </p>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="text-muted" style={{ fontSize: "11px" }}>
                                        {item.created_at ? new Date(item.created_at).toLocaleDateString() : ""}
                                      </span>
                                      {getStatusBadge(item.status)}
                                    </div>
                                  </div>
                                </div>
                              </LI>
                            );
                          })}
                        </UL>
                      ) : (
                        <div className="text-center p-4 text-muted">
                          <MessageSquare size={32} className="mb-2 text-muted" />
                          <p className="mb-0">No customer support tickets found.</p>
                        </div>
                      )}
                    </>
                  </TabPane>
                </TabContent>
              )}
            </div>
          </Card>
        </Col>

        {/* Right Chat & Detail Panel */}
        <Col
          xxl={9}
          xl={8}
          md={7}
          xs={12}
          className={`box-col-7 ${mobileShowChat ? "d-block" : "d-none d-md-block"}`}
        >
          <Card className="right-sidebar-chat shadow-sm h-100 mb-0">
            {selectedSupport ? (
              <>
                {/* Header Bar */}
                <div className="right-sidebar-title p-3 border-bottom bg-white">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-outline-secondary btn-sm me-1 d-md-none"
                        onClick={() => setMobileShowChat(false)}
                        title="Back to Tickets"
                      >
                        <ArrowLeft size={16} />
                      </button>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center fw-bold text-white"
                        style={{
                          width: "40px",
                          height: "40px",
                          background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)",
                          fontSize: "14px",
                        }}
                      >
                        {getInitials(selectedSupport.name || "Customer")}
                      </div>
                      <div>
                        <h6 className="mb-0 text-dark fw-bold">{selectedSupport.name || "Customer"}</h6>
                        <span className="text-muted small">Ticket #{selectedSupport.ticket}</span>
                      </div>
                    </div>
                    <div>
                      {selectedSupport?.status === "Resolved" ? (
                        <span className="badge bg-success-light text-success fw-bold px-3 py-2 border border-success">
                          <i className="fa fa-check-circle me-1" /> Resolved
                        </span>
                      ) : (
                        <button
                          className="btn btn-success btn-sm px-3 fw-semibold"
                          onClick={handleResolveTicket}
                          disabled={isResolving}
                        >
                          {isResolving ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" />
                              Resolving...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-check-circle me-1" /> Mark Resolved
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className="right-sidebar-Chats p-3" style={{ height: "calc(100vh - 270px)", overflowY: "auto" }}>
                  <div className="msger">
                    <div className="msger-chat" ref={chatHistoryRef}>
                      {isLoadingChat ? (
                        <div className="d-flex flex-column align-items-center justify-content-center h-100 p-5 my-auto" style={{ minHeight: "350px" }}>
                          <Spinner color="primary" />
                          <p className="mt-2 text-muted fw-semibold">Loading conversation...</p>
                        </div>
                      ) : (
                        <>
                          {/* Ticket Summary Hero Card */}
                          {selectedSupport && (
                            <div className="card border-0 mb-4 shadow-sm rounded-3 overflow-hidden bg-light">
                              <div
                                className="p-3 text-white"
                                style={{ background: "linear-gradient(135deg, #1b9aaa 0%, #16827c 100%)" }}
                              >
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                  <div>
                                    <span className="badge bg-white text-dark me-2">
                                      #{selectedSupport.ticket}
                                    </span>
                                    <strong className="fs-6">{selectedSupport.category || "Support Query"}</strong>
                                  </div>
                                  <div>
                                    {getStatusBadge(selectedSupport.status)}
                                  </div>
                                </div>
                              </div>
                              <div className="card-body p-3 bg-white">
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                                  <span className="text-muted small">
                                    <Clock size={12} className="me-1" /> Created:{" "}
                                    {selectedSupport.created_at ? new Date(selectedSupport.created_at).toLocaleString() : "N/A"}
                                  </span>
                                  {selectedSupport.file && (
                                    <a
                                      href={`${mediaUrl}/${selectedSupport.file}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-xs btn-outline-primary px-2 py-1"
                                    >
                                      <Paperclip size={12} className="me-1" /> View Attachment
                                    </a>
                                  )}
                                </div>
                                <div className="p-3 bg-light rounded border">
                                  <strong className="text-dark d-block small mb-1">Issue Description:</strong>
                                  <span className="text-dark small">{selectedSupport.description}</span>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Conversation Messages */}
                          {customerChat && customerChat.length > 0 ? (
                            customerChat.map((item: any, index: number) => {
                              const isCustomer = item.customer_id !== null;
                              return (
                                <div
                                  className={`msg ${isCustomer ? "left" : "right"}-msg mb-3`}
                                  key={index}
                                >
                                  <div className="msg-bubble p-3 rounded-3 shadow-sm" style={{
                                    maxWidth: "75%",
                                    backgroundColor: isCustomer ? "#ffffff" : "#16827c",
                                    color: isCustomer ? "#212529" : "#ffffff",
                                    border: isCustomer ? "1px solid #e2e8f0" : "none",
                                  }}>
                                    <div className="msg-info d-flex justify-content-between align-items-center mb-1 gap-3">
                                      <strong className="msg-info-name small" style={{ color: isCustomer ? "#16827c" : "#f8fafc" }}>
                                        {isCustomer ? (selectedSupport.name || "Customer") : "Support Admin"}
                                      </strong>
                                      <span className="msg-info-time small" style={{ fontSize: "10px", opacity: 0.8 }}>
                                        {new Date(item.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                      </span>
                                    </div>
                                    <div className="msg-text" style={{ fontSize: "13px", lineHeight: "1.4" }}>
                                      {item.message}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="text-center p-4 my-4">
                              <MessageSquare size={40} className="text-muted mb-2" />
                              <h6 className="text-dark fw-bold">Start Conversation</h6>
                              <p className="text-muted small">Send a message below to communicate with customer.</p>
                            </div>
                          )}
                        </>
                      )}
                      <div ref={bottomRef} />
                    </div>
                  </div>
                </div>

                {/* Send Message Area */}
                <div className="p-3 border-top bg-white">
                  {selectedSupport?.status === "Resolved" ? (
                    <div className="alert alert-success text-center mb-0 py-2 small fw-semibold">
                      <CheckCircle size={14} className="me-1" /> This support ticket has been resolved.
                    </div>
                  ) : (
                    <Form className="d-flex align-items-center gap-2" onSubmit={(e) => handleSubmit(e)}>
                      <Input
                        type="text"
                        className="form-control flex-grow-1"
                        placeholder="Type your response message..."
                        value={messageInput}
                        onChange={(e) => handleMessageChange(e.target.value)}
                      />
                      <Btn
                        color="primary"
                        className="d-flex align-items-center justify-content-center px-3"
                        disabled={isSending || !messageInput.trim()}
                        style={{ height: "38px" }}
                      >
                        {isSending ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                            Sending...
                          </>
                        ) : (
                          <>
                            <Send size={14} className="me-1" /> Send
                          </>
                        )}
                      </Btn>
                    </Form>
                  )}
                </div>
              </>
            ) : (
              /* Empty Selection State */
              <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5 my-auto" style={{ minHeight: "400px" }}>
                <div className="p-4 bg-light-primary rounded-circle mb-3">
                  <MessageSquare size={48} className="text-primary" />
                </div>
                <h4 className="fw-bold text-dark mb-2">Customer Support Portal</h4>
                <p className="text-muted mb-0" style={{ maxWidth: "380px" }}>
                  Select any support ticket from the left sidebar to inspect details, download attachments, and respond to customer queries.
                </p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}
